// Ebon activation types
export const EBON_ACTIVATION_TYPE_ONLINE = 'ONLINE';
export const EBON_ACTIVATION_TYPE_OFFLINE = 'OFFLINE';
export const EBON_ACTIVATION_TYPE_ONLINE_AND_OFFLINE = 'ONLINE_AND_OFFLINE';

// Ebon code types
export const EBON_TYPE_DOWNLOAD_CODE = 'DOWNLOAD_CODE';
export const EBON_TYPE_LINK_CODE = 'LINK_CODE';
export const EBON_TYPE_PRE_DOWNLOADED_LINK = 'PRE_DOWNLOADED_LINK';

// Enterprise card
export const ENTERPRISE_CARD_ENABLED = false;
export const ENTERPRISE_CARD_NAME = 'E-card';
export const ENTERPRISE_CARD_PARTNER_EBC_ID = 113;

// Ebon instant discount
export const HAS_INSTANT_DISCOUNT = true;

// Ebon parity
export const USE_PARITY = false;
export const COIN_NAME = '';

// Ebon user state (order card on account page)
export const EBON_USER_STATE_UNKNOWN = 'UNKNOWN';
export const EBON_USER_STATE_CURRENTLY_IN_USE = 'CURRENTLY_IN_USE';
export const EBON_USER_STATE_PENDING = 'PENDING';
export const EBON_USER_STATE_USED = 'USED';
export const EBON_USER_STATE_VALIDATED = 'VALIDATED';

export const EBON_USER_STATES_IN_PROGRESS = [
    EBON_USER_STATE_UNKNOWN,
    EBON_USER_STATE_CURRENTLY_IN_USE,
    EBON_USER_STATE_PENDING
];

export const EBON_USER_STATES_CONSUMED = [EBON_USER_STATE_USED, EBON_USER_STATE_VALIDATED];

export const EBON_TAB_IN_PROGRESS = 'EN_COURS';
export const EBON_TAB_CONSUMED = 'CONSOMMES';

// Free facial value proposals: candidates when the API returns no facial value (same as Plebicard V2)
export const FREE_FACIAL_DEFAULT_VALUES = [10, 20, 30, 50, 100, 150, 200, 300, 400, 500];
export const FREE_FACIAL_DEFAULT_PROPOSALS_COUNT = 4;
export const FREE_FACIAL_PROPOSAL_QUANTITY = 20;
export const FREE_FACIAL_PROPOSAL_EXPIRATION_DATE = 32503680000000;



// WEBPACK FOOTER //
// ./src/constants/ebon.js